export const albums = [
    {
        title: "Perfect Arrange Works ~Episode II~",
        cover: "/albums/compressed-album-images/PAW2.jpg",
        youtubeLink: "https://www.youtube.com/embed/fN1gEkX_eK4",
        desc: "This album never truly ends... This second episode of Xeno arrangements continues the saga with a focus on music from Xenoblade Chronicles and Xenoblade Chronicles X.|Perfect Arrange Works ~Episode II~ celebrates the rich 25+ year history of Xeno series music, this time including music from Xenosaga Freaks and Xenosaga I・II (DS)."
    },
    {
        title: "Falcom Café",
        cover: "/albums/compressed-album-images/Falcafe.jpg",
        youtubeLink: "https://www.youtube.com/embed/F999SCap668",
        desc: "We're officially open for business! Falcom Café is the one stop shop for sweet drinks, delicious food, and cozy arrangements of Falcom music!|Falcom Café is a cozy 13-track album to kick back and relax to. The perfect pair to a warm cup of coffee and a good book!"
    },
    {
        title: "Perfect Arrange Works ~Episode I~",
        cover: "/albums/compressed-album-images/PAW1.jpg",
        youtubeLink: "https://www.youtube.com/embed/wHjv8pEAvDM",
        desc: "Let the soundtrack take you. Join us for the first episode of a three album saga exploring a selection of music from Xenogears, Xenosaga, and the Xenoblade Chronicles series!|Perfect Arrange Works ~Episode I~ celebrates the rich 25+ year history of Xeno series music, including a few surprises along the way…"
    },
    {
        title: "Falcom Boss Rush Phase 3",
        cover: "/albums/compressed-album-images/FBR3.jpg",
        youtubeLink: "https://www.youtube.com/embed/Y1ju5R5stOc",
        desc: "Prepared to face the final boss? The final installment in the series, Falcom Boss Rush Phase 3 brings the gauntlet to an epic conclusion in an acoustic/orchestral fashion!|A tribute to Nihon Falcom’s boss themes over the years, this album includes several tracks from the hit Trails series. Rise above and claim your victory!!"
    },
    {
        title: "Falcom Boss Rush Phase 2",
        cover: "/albums/compressed-album-images/FBR2.jpg",
        youtubeLink: "https://www.youtube.com/embed/WaWpoUld0Ew",
        desc: "Don’t stop now. The second installment in the series, Falcom Boss Rush Phase 2 continues the run with a variety of electrifying electronic arrangements!|A tribute to Nihon Falcom’s boss themes over the years, this album includes several tracks from Tokyo Xanadu. One wrong move and everything ends…"
    },
    {
        title: "Falcom Boss Rush Phase 1",
        cover: "/albums/compressed-album-images/FBR1.jpg",
        youtubeLink: "https://www.youtube.com/embed/c29hCz4fQkM",
        desc: "Steel yourself for the coming battle! The start of a series, Falcom Boss Rush Phase 1 sprints out of the gate swinging hard with rock and metal arrangements!|A tribute to Nihon Falcom’s boss themes over the years, this album includes several tracks from the hit Ys series. Do you have what it takes to join the fight!?"
    },
    {
        title: "Guru Guru Jam!",
        cover: "/albums/compressed-album-images/GuruGuru.jpg",
        youtubeLink: "https://www.youtube.com/embed/elaIbbXglyw",
        desc: "Embark on a journey back to your childhood with this funky tribute album to Nihon Falcom’s Gurumin: A Monstrous Adventure!|Guru Guru Jam! is a 14-track experience that brings back the magic of friendship, and is sure to get you dancing!",
        link: "https://vgmcon.org/2024-game-music-remix-awards/",
        linkLabel: "“Best Album” 2024 Game Music Remix Award Winner"
    },
    {
        title: "Days of Adventure",
        cover: "/albums/compressed-album-images/Days.jpg",
        youtubeLink: "https://www.youtube.com/embed/pWpoqSYkP0k",
        desc: "Prepare for adventure! Set sail and explore the world in this 35th anniversary tribute album to Nihon Falcom’s Ys series.|Days of Adventure is a 14-track expedition that explores the series’ rich history of music in the context of a day/night cycle, representing each game in the series."
    },
    {
        title: "Resonant Saga",
        cover: "/albums/compressed-album-images/Resaga.jpg",
        youtubeLink: "https://www.youtube.com/embed/rte-z5qkq4U",
        desc: "This is where it all begins. Experience Resonant Union’s first album, a tribute to Nihon Falcom’s Legends of Heroes series.|Resonant Saga is a grand two and a half hour album that includes arrangements from the Dragon Slayer, Gagharv, and Trails series."
    },
]
